import { useState, useEffect } from 'react';
import { User } from '@/types';
import { getAllUsers } from '@/services/user.service';
import { logPageView, logError } from '@/services/analytics.service';
import { UserList } from '@/components/organisms/UserList';
import { PageHeader } from '@/components/organisms/PageHeader';
import { SearchInput } from '@/components/molecules/SearchInput';

export const UsersPage = () => {

  const [users, setUsers] = useState<User[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    logPageView('Browse Users Page');
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const allUsers = await getAllUsers();
        setUsers(allUsers);
        setFilteredUsers(allUsers);
      } catch (error) {
        console.error('Error fetching users:', error);
        const errorMessage =
          error instanceof Error ? error.message : 'Failed to fetch users';
        logError('Browse Users Fetch Error', errorMessage, 'UsersPage');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredUsers(users);
    } else {
      const query = searchQuery.toLowerCase();
      const filtered = users.filter(
        (user) =>
          user.username.toLowerCase().includes(query) ||
          user.email.toLowerCase().includes(query)
      );
      setFilteredUsers(filtered);
    }
  }, [searchQuery, users]);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <PageHeader title="Browse Users" showBackButton />

      {/* Search and Filters */}
      <section className="border-b border-border bg-muted/50">
        <div className="max-w-[1200px] mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
            <div className="flex-1 w-full md:max-w-md">
              <SearchInput
                placeholder="Search users by username or email..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="text-sm text-muted-foreground">
              {filteredUsers.length} user{filteredUsers.length !== 1 ? 's' : ''}{' '}
              found
            </div>
          </div>
        </div>
      </section>

      {/* Users Section */}
      <section className="max-w-[1200px] mx-auto px-4 py-12">
        <UserList users={filteredUsers} loading={loading} />
      </section>
    </div>
  );
};


